import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';

export const getApifonConfigurationState = createSelector(
  getDragonflyState,
  (state) => state?.apifonConfiguration,
);

export const getConfigurationTypeApifon = createSelector(
  getApifonConfigurationState,
  (state) => state?.configurationTypeApifon,
);

export const getNameApifon = createSelector(
  getApifonConfigurationState,
  (state) => state?.nameApifon,
);

export const getStatusApifon = createSelector(
  getApifonConfigurationState,
  (state) => state?.statusApifon,
);

export const getSmsSenderApifon = createSelector(
  getApifonConfigurationState,
  (state) => state?.smsSenderApifon,
);

export const getViberSenderApifon = createSelector(
  getApifonConfigurationState,
  (state) => state?.viberSenderApifon,
);

export const getApiKeyApifon = createSelector(
  getApifonConfigurationState,
  (state) => state?.apiKeyApifon,
);

export const getTokenApifon = createSelector(
  getApifonConfigurationState,
  (state) => state?.tokenApifon,
);

export const getIsSelectedConfig = createSelector(
  getApifonConfigurationState,
  (state) => state?.isSelectedConfig,
);

export const getIsSelectedConfigViberSms = createSelector(
  getApifonConfigurationState,
  (state) => state?.isSelectedConfigViberSms,
);

export const getShowUpdateBtn = createSelector(
  getApifonConfigurationState,
  (state) => state?.showUpdateBtn,
);

export const getDisableNameValue = createSelector(
  getApifonConfigurationState,
  (state) => state?.disableName,
);

export const getIntegrationConfigurationHelpTextStatus = createSelector(
  getApifonConfigurationState,
  (state) => state?.integrationConfigurationHelpTextStatus,
);

export const getCredentialsConfigurationHelpTextStatus = createSelector(
  getApifonConfigurationState,
  (state) => state?.credentialsConfigurationHelpTextStatus,
);

export const getCampaignReportingHelpTextStatus = createSelector(
  getApifonConfigurationState,
  (state) => state?.campaignReportingHelpTextStatus,
);

export const getLookBackDaysApifon = createSelector(
  getApifonConfigurationState,
  (state) => state?.lookBackDaysApifon,
);

export const getSelectedApifonDataFromGrid = createSelector(
  getApifonConfigurationState,
  (state) => state?.selectedApifonDataFromGrid,
);

export const getShowCancelBtn = createSelector(
  getApifonConfigurationState,
  (state) => state?.showCancelBtn,
);

export const getApifonDataIsSubmitted = createSelector(
  getApifonConfigurationState,
  (state) => state?.isSubmittedData,
);

export const getShowNameErrorMsg = createSelector(
  getNameApifon,
  getApifonDataIsSubmitted,
  (name, dataIsSubmitted) => (!name && dataIsSubmitted ? true : false),
);

export const getShowSmsSenderErrorMsg = createSelector(
  getSmsSenderApifon,
  getApifonDataIsSubmitted,
  (smsSender, dataIsSubmitted) => (!smsSender && dataIsSubmitted ? true : false),
);

export const getShowViberSenderErrorMsg = createSelector(
  getViberSenderApifon,
  getApifonDataIsSubmitted,
  (viberSender, dataIsSubmitted) => (!viberSender && dataIsSubmitted ? true : false),
);

export const getShowApiKeyErrorMsg = createSelector(
  getApiKeyApifon,
  getApifonDataIsSubmitted,
  getShowUpdateBtn,
  (apiKey, dataIsSubmitted, isEditMode) =>
    !apiKey && dataIsSubmitted && !isEditMode ? true : false,
);

export const getShowApiTokenErrorMsg = createSelector(
  getTokenApifon,
  getApifonDataIsSubmitted,
  getShowUpdateBtn,
  (apiToken, dataIsSubmitted, isEditMode) =>
    !apiToken && dataIsSubmitted && !isEditMode ? true : false,
);

export const getShowLookBackDaysErrorMsg = createSelector(
  getLookBackDaysApifon,
  getApifonDataIsSubmitted,
  (lookBackDays, dataIsSubmitted) => (lookBackDays === null && dataIsSubmitted ? true : false),
);

export const getApifonDataAreValid = createSelector(
  getConfigurationTypeApifon,
  getNameApifon,
  getSmsSenderApifon,
  getViberSenderApifon,
  getApiKeyApifon,
  getTokenApifon,
  getLookBackDaysApifon,
  getShowUpdateBtn,
  (
    configurationTypeApifon,
    name,
    smsSender,
    viberSender,
    apiKey,
    apiToken,
    lookBackDays,
    isEditMode,
  ) => {
    const apiKeyValid = !!apiKey || isEditMode;
    const apiTokenValid = !!apiToken || isEditMode;
    return configurationTypeApifon === 'APIFON_VIBER_SMS'
      ? name && smsSender && viberSender && apiKeyValid && apiTokenValid && lookBackDays !== null
        ? true
        : false
      : name && smsSender && apiKeyValid && apiTokenValid && lookBackDays !== null
        ? true
        : false;
  },
);
